import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@api/core';

import {
  BasicPatientHistory,
  PatientHistory
} from '@api/patient/history';

const API_URL = 'history_formulary_completed';

@Injectable()
export class PatientHistoryApiService {

  constructor(private api: ApiService) { }

  get(historyId: number): Observable<PatientHistory[]> {
    return this.api.get<PatientHistory[]>(API_URL, `/${historyId}`);
  }

  getByPerson(personId: number): Observable<PatientHistory[]> {
    return this.api.get<PatientHistory[]>(API_URL, `?personId=${personId}`);
  }

  saveCompletedHistory(historyFormularyId: number, historyCompleted: BasicPatientHistory): Observable<any> {
    return this.api.post(API_URL, `?historyFormularyId=${historyFormularyId}`, historyCompleted);
  }

  getHistoryByMedicalConsultation(medicalConsultation: number): Observable<PatientHistory> {
    return this.api.get<PatientHistory>(API_URL, `/formularyMedicalConsultation?medicalConsultationId=${medicalConsultation}`);
  }
  updateCompletedHistory(historyCompletedId: number, historyCompleted: BasicPatientHistory): Observable<any> {
    return this.api.put(API_URL, `/${historyCompletedId}`, historyCompleted);
  }

  saveQuestions(historyFormularyId: number, historyCompleted: BasicPatientHistory): Observable<any> {
    return this.api.post(API_URL, `?historyFormularyId=${historyFormularyId}`, historyCompleted);
  }
}
